import { getInstance } from "../../core/axios-gateway";
import { TTenantSettingsDTO, TTenantSettingsResponse } from "../../types/tenant-settings";

const BASE_PATH = "/api/suppliers";

export const getSupplierSettings = async () => {
  return getInstance()
    .get<TTenantSettingsResponse>(`${BASE_PATH}/settings`)
    .then((res) => res.data);
};

export const updateSupplierSettings = async (settings: TTenantSettingsDTO) => {
  return getInstance()
    .put<TTenantSettingsResponse>(`${BASE_PATH}/settings`, { settings })
    .then((res) => res.data);
};
